import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import servicesBoxStyles from './servicesBoxStyles.module.scss';
import boxStyles from '../boxes/boxes.module.scss';
import { actions } from '../../../state';
import { Toggle, ButtonSimple, InputElement } from '../../../components';
import RemoveButton from '../../../components/removeButton/RemoveButton';

const newRow = () => ({ serial: '', status: 1 });

const CashRegisters = ({ dispatch, data, requestError }) => {
  const [rows, setRows] = useState(data && data.length ? data : [newRow()]);

  useEffect(() => {
    dispatch(actions.addEditServices.pushCashRegistersAction(rows));
  });

  const updateRows = nextRows => {
    setRows(nextRows);
  };

  const handleSerialChange = (index, value) => {
    const next = rows.map((row, i) =>
      i === index ? { ...row, serial: value } : row
    );
    updateRows(next);
  };

  const handleToggle = index => {
    const next = rows.map((row, i) =>
      i === index ? { ...row, status: row.status === 1 ? 0 : 1 } : row
    );
    updateRows(next);
  };

  const handleAdd = () => {
    const withoutDeleted = rows.filter(row => !row.deleted);
    const deletedItems = rows.filter(row => row.deleted);
    updateRows([...withoutDeleted, newRow(), ...deletedItems]);
  };

  const handleRemove = (index, id) => {
    let next = [...rows];

    if (id) {
      next[index] = { ...next[index], deleted: true };
      updateRows(next);
      setTimeout(() => {
        dispatch(actions.locations.addLocationsAction());
        setTimeout(() => {
          const remaining = next.filter(row => !row.deleted);
          updateRows(remaining.length ? remaining : [newRow()]);
        }, 100);
      }, 100);
      return;
    }

    next = next.filter((_, i) => i !== index);
    updateRows(next.length ? next : [newRow()]);
  };

  return (
    <div className={servicesBoxStyles.mainContainer}>
      <div className={boxStyles.box}>
        <table className={boxStyles.container}>
          <thead>
            <tr>
              <th>Serijos numeris</th>
              <th style={{ width: 50 }}>Būsena</th>
              <th style={{ width: 25 }} />
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => {
              if (row.deleted) {
                return null;
              }

              return (
                <tr key={row.id || `new-${idx}`}>
                  <td>
                    <InputElement
                      type="text"
                      placeholder="Serijos numeris"
                      value={row.serial || ''}
                      onChange={e => handleSerialChange(idx, e.target.value)}
                      invalid={requestError && !String(row.serial || '').trim()}
                    />
                  </td>
                  <td>
                    <Toggle
                      checked={row.status === 1}
                      onChange={() => handleToggle(idx)}
                    />
                  </td>
                  <td style={{ width: 25 }}>
                    <RemoveButton
                      title="Pašalinti kasą"
                      desc="Ar tikrai norite pašalinti kasą?"
                      onClick={() => handleRemove(idx, row.id)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className={boxStyles.addBox}>
          <ButtonSimple type="add" onClick={handleAdd}>
            Pridėti
          </ButtonSimple>
        </div>
      </div>
    </div>
  );
};

CashRegisters.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      serial: PropTypes.string,
      status: PropTypes.number,
      deleted: PropTypes.bool,
    })
  ),
  requestError: PropTypes.bool,
};

export default connect()(CashRegisters);
